import { Card, Tabs } from 'antd';
import { Outlet, useMatch } from 'react-router-dom';

import useAPIQuery from '../../api/useAPIQuery';
import Page from '../../components/Page';
import PageContent from '../../components/PageContent';
import PageTitle from '../../components/PageTitle';
import useTypedNavigate from '../../hooks/useTypedNavigate';
import useTypedParams from '../../hooks/useTypedParams';

const SettingsNavigator = () => {
  const { tenant } = useTypedParams({ tenant: String });
  const navigate = useTypedNavigate();
  const match = useMatch(':tenant/settings/:activeTabKey/*');
  const activeTabKey = match?.params?.activeTabKey || 'company-info';
  const user = useAPIQuery('/users/me/');
  const config = useAPIQuery('/configs/tenant-configurations/');

  return (
    <Page>
      <PageTitle title="Configurações" />
      <PageContent>
        <Card>
          <Tabs
            tabPosition="left"
            activeKey={activeTabKey}
            onChange={(key) => {
              switch (key) {
                case 'company-info':
                  navigate(
                    { pathname: '/:tenant/settings/company-info/', params: { tenant } },
                    { replace: true }
                  );
                  break;
                case 'accessManagement':
                  navigate(
                    { pathname: '/:tenant/settings/accessManagement/', params: { tenant } },
                    { replace: true }
                  );
                  break;
                case 'integrations':
                  navigate(
                    { pathname: '/:tenant/settings/integrations/', params: { tenant } },
                    { replace: true }
                  );
                  break;
                case 'candidateRegisterFields':
                  navigate(
                    {
                      pathname: '/:tenant/settings/candidateRegisterFields/',
                      params: { tenant },
                    },
                    { replace: true }
                  );
                  break;
                case 'emailTemplates':
                  navigate(
                    { pathname: '/:tenant/settings/emailTemplates/', params: { tenant } },
                    { replace: true }
                  );
                  break;
                case 'candidate-tags':
                  navigate(
                    { pathname: '/:tenant/settings/candidate-tags/', params: { tenant } },
                    { replace: true }
                  );
                  break;
                case 'requestJobPostingTemplates':
                  navigate(
                    {
                      pathname: '/:tenant/settings/requestJobPostingTemplates/',
                      params: { tenant },
                    },
                    { replace: true }
                  );
                  break;
                case 'interviewScriptTemplates':
                  navigate(
                    {
                      pathname: '/:tenant/settings/interviewScriptTemplates/',
                      params: { tenant },
                    },
                    { replace: true }
                  );
                  break;
                case 'cs-staff':
                  if (user.data?.is_staff) {
                    navigate(
                      {
                        pathname: '/:tenant/settings/cs-staff/',
                        params: { tenant },
                      },
                      { replace: true }
                    );
                  } else {
                    navigate(
                      { pathname: '/:tenant/settings/company-info/', params: { tenant } },
                      { replace: true }
                    );
                  }
                  break;
              }
            }}
            style={{ paddingRight: 24 }}
            items={[
              {
                key: 'company-info',
                label: 'Dados da Empresa',
                children: activeTabKey === 'company-info' && <Outlet />,
              },
              {
                key: 'accessManagement',
                label: 'Gestão de Acessos',
                children: activeTabKey === 'accessManagement' && <Outlet />,
              },
              {
                key: 'integrations',
                label: 'Integrações',
                children: activeTabKey === 'integrations' && <Outlet />,
              },
              {
                key: 'candidateRegisterFields',
                label: 'Formulário de Inscrição',
                children: activeTabKey === 'candidateRegisterFields' && <Outlet />,
              },
              {
                key: 'emailTemplates',
                label: 'Modelos de Email',
                children: activeTabKey === 'emailTemplates' && <Outlet />,
              },
              {
                key: 'candidate-tags',
                label: 'Tags dos Candidatos',
                children: activeTabKey === 'candidate-tags' && <Outlet />,
              },
              {
                key: 'requestJobPostingTemplates',
                label: 'Requisição de Vagas',
                children: activeTabKey === 'requestJobPostingTemplates' && <Outlet />,
              },
              ...(config.data?.t002_enableCandidateInterview
                ? [
                    {
                      key: 'interviewScriptTemplates',
                      label: 'Roteiros de Entrevista',
                      children: activeTabKey === 'interviewScriptTemplates' && <Outlet />,
                    },
                  ]
                : []),
              ...(user.data?.is_staff
                ? [
                    {
                      key: 'cs-staff',
                      label: 'Área do CS',
                      children: activeTabKey === 'cs-staff' && <Outlet />,
                    },
                  ]
                : []),
            ]}
          />
        </Card>
      </PageContent>
    </Page>
  );
};

export default SettingsNavigator;
